// Insert hotjar code into public html file with hjid depending on env variable
(function(h,o,t,j,a,r){
  if ('VUE_APP_HOTJAR_SITE_ID' in process.env) {
    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
    h._hjSettings={hjid:process.env.VUE_APP_HOTJAR_SITE_ID,hjsv:6};
    a=o.getElementsByTagName('head')[0];
    r=o.createElement('script');r.async=1;
    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
    a.appendChild(r);
    console.log(`Hotjar loaded for site : ${process.env.VUE_APP_HOTJAR_SITE_ID}`)
  }
})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');